export default __webpack_public_path__ + "static/media/116-BBR-24.1c5ac0ba.png";